import {
  ApiBlueprint,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api';
import { providersApiRef } from '@internal/backstage-plugin-catalog-devops-react';
import {
  AccountApiClient,
  accountApiRef,
  CloudResourcesStatisticsApiClient,
  cloudResourcesStatisticsApiRef,
  CloudResourcesMenuApiClient,
  cloudResourcesMenuApiRef,
  CveApiClient,
  cveApiRef,
  ProvidersApiClient,
  RulesStatisticsApiClient,
  rulesStatisticsApiRef,
} from './api';
import { rootRouteRef } from './routes';
import tabs from './tabs';

const accountApi = ApiBlueprint.make({
  name: 'accountApi',
  params: defineParams =>
    defineParams({
      api: accountApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new AccountApiClient({ discoveryApi, fetchApi }),
    }),
});

const cveApi = ApiBlueprint.make({
  name: 'cveApi',
  params: defineParams =>
    defineParams({
      api: cveApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new CveApiClient({ discoveryApi, fetchApi }),
    }),
});

const providersApi = ApiBlueprint.make({
  name: 'providersApi',
  params: defineParams =>
    defineParams({
      api: providersApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new ProvidersApiClient({ discoveryApi, fetchApi }),
    }),
});

const rulesStatisticsApi = ApiBlueprint.make({
  name: 'rulesStatisticsApi',
  params: defineParams =>
    defineParams({
      api: rulesStatisticsApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new RulesStatisticsApiClient({ discoveryApi, fetchApi }),
    }),
});

const cloudResourcesStatisticsApi = ApiBlueprint.make({
  name: 'cloudResourcesStatisticsApi',
  params: defineParams =>
    defineParams({
      api: cloudResourcesStatisticsApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new CloudResourcesStatisticsApiClient({ discoveryApi, fetchApi }),
    }),
});

const cloudResourcesMenuApi = ApiBlueprint.make({
  name: 'cloudResourcesMenuApi',
  params: defineParams =>
    defineParams({
      api: cloudResourcesMenuApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new CloudResourcesMenuApiClient({ discoveryApi, fetchApi }),
    }),
});

export const catalogDevopsPlugin = createFrontendPlugin({
  pluginId: 'catalog-devops',
  routes: {
    root: rootRouteRef,
  },
  extensions: [
    accountApi,
    cveApi,
    providersApi,
    rulesStatisticsApi,
    cloudResourcesStatisticsApi,
    cloudResourcesMenuApi,
    ...tabs,
  ],
});
